import axios from "axios";

export const state = {
    other_systems: [],
    patient_other_systems: [],
    patient_system_status: false
};
export const getters = {
    OtherSystems: state => state.other_systems.data,
    PatientOtherSystems: state => state.patient_other_systems.data,
    PatientSystemStatus: state => state.patient_system_status
};
export const mutations = {
    SET_OTHER_SYSTEMS(state, newValue) {
        state.other_systems = newValue
    },
    SET_PATIENT_OTHER_SYSTEMS(state, newValue) {
        state.patient_other_systems = newValue
    },
    SET_ADD_SYSTEMS_STATUS(state, newValue) {
        state.patient_system_status = newValue
    },
};
export const actions = {
    fetchOtherSystems({ commit }) {
        axios.get('other_system').then(pi_res => {
            commit('SET_OTHER_SYSTEMS', pi_res.data)
        })
    },
    fetchPatientOtherSystems({ commit }, visit_id) {
        axios.get(`patient_systems/${visit_id}`).then(ps_res => {
            commit('SET_PATIENT_OTHER_SYSTEMS', ps_res.data)
        })
    },
    updatePatientOtherSystems({ commit }, system) {
        axios.put(`patientsystems/${system.id}`, system).then(() => {
            commit('SET_ADD_SYSTEMS_STATUS', false)
        })
    },
    addPatientOtherSystems({ commit, dispatch }, payload) {
        commit('SET_ADD_SYSTEMS_STATUS', true)
        axios.post(`patientsystems`, payload).then(() => {
            commit('SET_ADD_SYSTEMS_STATUS', false)
            dispatch('fetchPatientOtherSystems', payload.visit_id)
            let message = { 'msg': "System added successfully" }
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            commit('SET_ADD_SYSTEMS_STATUS', false)
            let message = { 'msg': "Error adding System" }
            dispatch('notification/error', message, { root: true })
        })
    },


};